import React from 'react';

export function AuthShell({ subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src={process.env.PUBLIC_URL + '/favicon.png'} alt="Sankhya" className="w-10 h-10 rounded-lg mb-4 inline-block" />
          <h1 className="text-2xl font-bold text-white font-['Outfit'] tracking-tight">Sankhya</h1>
          {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
        </div>

        <div className="bg-[#111111] border border-white/8 rounded-xl p-8 shadow-2xl">
          {children}
        </div>
      </div>
    </div>
  );
}

export function Field({ icon: Icon, label, type = 'text', value, onChange, placeholder, readOnly, autoFocus }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1.5 block">{label}</label>
      <div className="relative">
        {Icon && <Icon size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500 pointer-events-none" />}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          autoFocus={autoFocus}
          className={`w-full bg-[#0a0a0a] border rounded-lg py-2.5 text-sm text-white placeholder-zinc-600 focus:outline-none focus:border-amber-500/60 transition-colors ${Icon ? 'pl-9 pr-4' : 'px-4'} ${readOnly ? 'opacity-60 cursor-not-allowed border-white/5' : 'border-white/10'}`}
        />
      </div>
    </div>
  );
}

export function SubmitBtn({ loading, label }) {
  return (
    <button
      type="submit"
      disabled={loading}
      className="w-full py-2.5 bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-black font-bold rounded-lg text-sm transition-colors"
    >
      {loading ? 'Please wait…' : label}
    </button>
  );
}
